export const SEARCH_MANUFACTURER = 'Search Manufacturer';
export const TBILL_RATES = 'Maintain T-Bill Rates';
export const SEARCH_EXCLUDED_NDCS = 'Search Excluded NDCs';
export const SEARCH_CHECK = 'Search Check';
export const LOG_BATCH_TOTAL = 'Batch Total';
export const COMMENT_AND_CORRESPONDENCE = 'Comment';
export const ASSIGN_DISPUTE_SEARCH = 'Assign Dispute Search';
export const UNIT_CONVERSION = 'Select NDC for Unit Conversion';
export const CHECKS_BY_INVOICE = 'Checks By Invoice';
export const LABELER_DIFF = 'Labeler differences';
export const INVOICE_AUDITS_SEARCH = 'Invoice Audits Search';
export const SEARCH_CONTRACT = 'Contract Search';
export const SYSTEM_PARAMETER = 'System Parameters';
export const CMS_MISMATCH = 'CMS Mismatch ';
export const CMS_ROSI = 'CMS ROSI';
export const CLAIM_AUDIT_SELECT = 'Claim Audit Select ';
export const MANUFACTURER_DISPUTES = 'Manufacturer Disputes';
export const CMS_DRUG_FILE = 'CMS Drug File';
export const CMS_DRUG_FILE_DETAIL = 'CMS Drug File Detail';
export const CONTACT_ANOMALIES = 'Contact Anomalies';
export const ROSI_PQAS_INCONSISTENCIES = 'Search ROSI/PQAS Inconsistencies';
export const REQUEST_CURRENT_DISPUTE_DISPLAY =
  'Request Current Dispute Display ';
export const UNDER_THRESHOLD_INVOICE = 'Select Under Threshold Invoices';
export const REQUEST_DISPLAY_LETTER = 'Request Display Letter';
export const URA_SEARCH = 'View Calculated URA';
export const GENERATE_INVOICES = 'Generate Invoices';
export const REBATE_PROGRAM = 'Search Rebate Program';
export const ACC_RECEIVABLE = 'Request Accounts Receivable';
export const REBATE_PRICE_LEVEL = 'Search Rebate Price Level';
export const REBATE_PRICE_SEARCH = 'Search Rebate Price Details';
export const MAUNTAIN_REBATE_PRICE = 'Maintain Rebate Price Details';
export const RECORD_PROVIDER_REVIEW = 'Provider Review';
export const REQUEST_QUARTERLY_PAYMENT = 'Request Quarterly Payment Report';
export const REQUEST_INVOICES_QTR_NOT_PAID =
  'Req Invoices For Qtr not Paid Report';
export const REBATE_PERCENT_SPEND = 'Request Rebate Percent Of Spend';
export const INVOICE_REGISTER = 'Request Invoice Register Report';
export const PAYMENT_SUMMARY = 'Request Payment Summary Report';
export const TOP_BALANCES = 'Request Top Balances Report';
export const DISPUTE_ACTIVITY = 'Request Dispute Activity Summary Report';
export const ALLOCATE_PAYMENTS = 'Select Check to Allocate';
export const INVOICE_REPORTS = 'Invoice Reports';
export const UNALLOCATED_BALANCE = 'Req Unallocated Balance Report';
export const DISPUTE_AMOUNT = 'Request Dispute Amounts Report';
export const CHECK_ALLOCATION_COMPARISON = 'Req Check Allocation Comparison';
export const INTEREST_OVERRIDE = 'Req Interest Override Rpt';
export const INTEREST_RECIEVED = 'Req Interest Received Rpt';
export const CURRENT_ZERO_URA = 'Req Current Zero URA';
export const INIT_CMS64_REPORTS = 'Init Correct CMS64 Rpt';
export const HCPCS_CODE_CLAIMS_PAID = 'Req HCPCS Code Claims Paid';
export const NDC_DETAILS = 'Req NDC Details Rpt';
export const NDC_HISTORY = 'Request NDC History';
export const ZERO_URA = 'Req Zero URA Rpt';
export const OUTSTANDING_DISPUTES_NUM_DAYS =
  'Req Outstanding Disputes After Num of Days';
export const OUTSTANDING_DISPUTES_QUARTER =
  'Req Outstanding Disputes For Quarter';
export const MCO_CLAIMS = 'Req MCO Claims Rpt';
export const ADJUSTMENT_REASON_CODE = 'Req Adjustment By Reason Code';
export const INSTITUTIONAL_CLAIMS_TYPE_DISCREPANCY =
  'Req Institutional Claim Unit Type Discrepancy';
export const REQUEST_QUARTERLY_CMS_DRUG = 'Request Quarterly CMS Drug';
export const REQUEST_PREINVOICE_ADJUSTMENT =
  'Request PreInvoice Unit Adjustment';
export const REQUEST_PROGRAM_ELIGIBILTY =
  'Request Program and Eligibilty Category Report';
export const REQUEST_CURRENT_TO_PREVIOUS =
  'Request Current To Previous Quarter Invoice';
export const REQUEST_CASH_RECEIPT_SUMMARY = 'Req Cash Receipt Summary';
export const REQUEST_MANUFACTURER_SUMMARY = 'Req Manufacturer Summary';
export const REQUEST_DISPUTE_CODE = 'Request Dispute Code Summary';
export const REQUEST_ADJUSTMENT_DETAIL = 'Request CMS Adjustment Detail';
export const REQUEST_OUTSTANDING_BALANCE_BY_LABERER_AND_QUARTER =
  'Request Outstanding Balance By Labeler And Quarter';
export const REQUEST_ADJUSTED_CLAIMS = 'Request Adjusted Claims';
export const REQUEST_FAMILY_PLANNING_DRUGS_INVOICED_FOR_REBATES =
  'Req Family Planning Drugs Inv';
export const REQUEST_FAMILY_PLANNING_DRUGS_PAYMENT_RECEIVED =
  'Req Family Planning Drugs Pmt Rec';
export const NDC_PAYMENT_RPT = 'NDC Payment Rpt';
export const EXCLUDED_CLAIMS_RPT = 'Excluded Claims Rpt';
export const CHIP_CSHCN_RPT = 'Req CHIP/CSHCN Rates';
export const TERMINATED_LABELER = 'Request Terminated Labeler';
export const REQUEST_ACTIVE_LABELER = 'Request Active Labeler';
export const REQUEST_DRUGS_THERAPEUTIC_CLASS =
  'Request Drugs Therapeutic Class';
export const CHIP_CSHCN_RATE_AUDIT_RPT = 'Req CHIP/CSHCN Rate Audit';
export const SUPPLEMENTAL_RATES = 'Request Supplemental Rates';
export const UNIT_ADJUSTMENT = 'Request Unit Adjustments at NDC Level';
export const REQUEST_MANUFACTURER_OUTSTANDING_BALANCE =
  'Request Manufacturer Outstanding Balance';
export const SUBSTANCE_ABUSE = 'Request Substance Abuse Drug Report';
export const PROVIDER_CLAIM = 'Provider Claim List';
export const CMS_QUARTERLY_REPORTING = 'Summary Report CMS64';
export const REMINDER_RECIPIENT = 'Reminder Recipient';
export const DATA_NICHE_REPORT = 'Request Data Niche Report';
export const INELIGIBLE_CPT = 'Maintain Ineligible CPT';
